export const RECALL_BASE = "/recall";

export const recallPaths = {
  base: () => RECALL_BASE,
  campaigns: () => `${RECALL_BASE}/campaigns`,
  campaignNew: (prefill?: {
    cellLotRefs?: string[];
    seedPassportIds?: string[];
  }) => {
    const params = new URLSearchParams();
    if (prefill?.cellLotRefs?.length) {
      params.set("cellLotRefs", prefill.cellLotRefs.join(","));
    }
    if (prefill?.seedPassportIds?.length) {
      params.set("seedPassportIds", prefill.seedPassportIds.join(","));
    }
    const query = params.toString();
    return `${RECALL_BASE}/campaigns/new${query ? `?${query}` : ""}`;
  },
  campaignDetail: (id: string) => `${RECALL_BASE}/campaigns/${id}`,
  scope: (
    id: string,
    prefill?: { cellLotRefs?: string[]; seedPassportIds?: string[] }
  ) => {
    const params = new URLSearchParams();
    if (prefill?.cellLotRefs?.length) {
      params.set("cellLotRefs", prefill.cellLotRefs.join(","));
    }
    if (prefill?.seedPassportIds?.length) {
      params.set("seedPassportIds", prefill.seedPassportIds.join(","));
    }
    const query = params.toString();
    return `${RECALL_BASE}/campaigns/${id}/scope${query ? `?${query}` : ""}`;
  },
  trace: () => `${RECALL_BASE}/trace`,
};
